"use client";

import Link from "next/link";
import { useState } from "react";

import PhoneNumberModal from "../modals/PhoneNumberModal";

import { useMediaQuery } from "@/hooks/useMediaQuery";
import { trackOpenAICallUsDial } from "@/lib/analytics/openai-events";

interface PhoneLinkProps {
  phoneNumber: string;
  linkClassNames?: string;
  buttonClassNames?: string;
  trackingSource?: string;
  children: React.ReactNode;
}

const PhoneLink = ({
  phoneNumber,
  linkClassNames,
  buttonClassNames,
  trackingSource = "phone_link",
  children,
}: PhoneLinkProps) => {
  const [isPhoneNumberModalOpen, setIsPhoneNumberModalOpen] = useState(false);
  const isTabletOrLarger = useMediaQuery("(min-width: 768px)");

  if (isTabletOrLarger) {
    return (
      <>
        <button
          onClick={() => setIsPhoneNumberModalOpen(true)}
          className={buttonClassNames}
          dir="ltr"
          aria-label="Call us"
          tabIndex={0}
        >
          {children}
        </button>
        <PhoneNumberModal
          isOpen={isPhoneNumberModalOpen}
          onClose={() => setIsPhoneNumberModalOpen(false)}
          phoneNumber={phoneNumber}
          trackingSource={trackingSource}
        />
      </>
    );
  }

  return (
    <Link
      href={`tel:${phoneNumber}`}
      className={linkClassNames}
      dir="ltr"
      onClick={() => trackOpenAICallUsDial(trackingSource)}
    >
      {children}
    </Link>
  );
};

export default PhoneLink;
